import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { specraFocusRing } from './focus-ring';
/** Branded multiline field with deliberate vertical resizing. */ export const SpecraTextarea = /*#__PURE__*/ React.forwardRef(({ className, invalid = false, ...props }, ref)=>/*#__PURE__*/ _jsx("textarea", {
        "aria-invalid": invalid || undefined,
        className: cn('min-h-[var(--space-20)] w-full resize-y rounded-[var(--radius-control)] border border-input bg-card px-[var(--space-2-5)] py-[var(--space-2)] text-[length:var(--fs-ui)] leading-[var(--lh-snug)] text-foreground placeholder:text-[color:var(--text-placeholder)] disabled:cursor-not-allowed disabled:opacity-50', specraFocusRing, invalid && 'border-danger', className),
        ref: ref,
        ...props
    }));
SpecraTextarea.displayName = 'SpecraTextarea';
